module.exports = __webpack_public_path__ + "public/fonts/RWSTTDd.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/fonts/RWSTTDd.woff
// module id = 697
// module chunks = 0